import { computed } from "vue";

export function useRequirements(size, coType) {
  //show required activities
  const needsWklyWrkPlcInspect = computed(() => {
    return size.value >= 50;
  });

  const needsMnthlyWrkPlcInspect = computed(() => {
    return size.value >= 50;
  });

  const needsMnthlyHlthCmmttMeeting = computed(() => {
    return size.value >= 50;
  });

  const needsMnthlyHlthSftyCmmttMeeting = computed(() => {
    return (
      (size.value >= 50 && coType.value == "construction") ||
      (size.value >= 100 && coType.value == "retail")
    );
  });

  const needsAnnlHlthChckAdmin = computed(() => {
    return true;
  });

  const needsAnnlHlthChckExam = computed(() => {
    return true;
  });

  const needsAnnlHlthChck = computed(() => {
    return true;
  });

  const needsAnnlStrssCheck = computed(() => {
    return size.value >= 50;
  });

  const needsAdhocPrsnlReporting = computed(() => {
    return size.value >= 10;
  });

  const needsAdhocIncdntReporting = computed(() => {
    return true;
  });

  const needsSetup = computed(() => {
    return size.value >= 50;
  });

  //show required number of participants

  const healthClinic = computed(() => {
    return 1;
  });

  const nbIndusPhysician = computed(() => {
    if (size.value < 50) {
      return 0;
    } else if (size.value < 3000) {
      return 1;
    } else {
      return 2;
    }
  });

  const nbHlthPromoter = computed(() => {
    if (size.value >= 10 && size.value < 50 && coType.value == "office") {
      return 1;
    } else return 0;
  });

  const nbHlthSftyPromoter = computed(() => {
    if (
      size.value >= 10 &&
      size.value < 50 &&
      (coType.value == "retail" || coType.value == "construction")
    ) {
      return 1;
    } else return 0;
  });

  const nbHlthOfficer = computed(() => {
    if (size.value < 50) {
      return 0;
    } else if (size.value < 200) {
      return 1;
    } else if (size.value < 500) {
      return 2;
    } else if (size.value < 1000) {
      return 3;
    } else if (size.value < 2000) {
      return 4;
    } else if (size.value < 3000) {
      return 5;
    } else {
      return 6;
    }
  });

  const nbCmpnyMgmt = computed(() => {
    return 1;
  });

  const requiredCmpnyMgmt = computed(() => {
    if (nbHlthSftyManager.value == 1) {
      return 0;
    } else {
      return 1;
    }
  });

  const requiredClinic = computed(() => {
    if (size.value < 50) {
      return 1;
    } else {
      return 0;
    }
  });

  const requiredCmpnyMgmtIncRprt = computed(() => {
    if (size.value < 10) {
      return 1;
    } else {
      return 0;
    }
  });

  const nbEmplyRepresentative = computed(() => {
    if ((size.value >= 50 && (coType.value == 'retail' || coType.value == 'construction')) || needsSftyOfficer.value == true ){
      return 3;
    }
    else if (size.value < 50) {
      return 0;
    } else {
      return 2;
    }
  });

  const nbSftyOfficer = computed(() => {
    if (
      size.value >= 50 &&
      (coType.value == "retail" || coType.value == "construction")
    ) {
      return 1;
    } else {
      return 0;
    }
  });

  const nbHlthSftyManager = computed(() => {
    if (size.value >= 100 && coType.value == "construction") {
      return 1;
    } else if (size.value >= 300 && coType.value == "retail") {
      return 1;
    } else if (size.value >= 1000 && coType.value == "office") {
      return 1;
    } else {
      return 0;
    }
  });

  const needsHlthChckSummary = computed(() => {
    return size.value >= 50;
  });

  const needsHlthCmmtt = computed(() => {
    return size.value >= 50;
  });

  const needsIndusPhysician = computed(() => {
    return size.value >= 50;
  });

  const needsSftyOfficer = computed(() => {
    return (size.value >= 50 && coType.value == 'construction') || (size.value >= 100 && coType.value == 'retail');
  });

  return {
    needsWklyWrkPlcInspect,
    needsMnthlyWrkPlcInspect,
    needsMnthlyHlthCmmttMeeting,
    needsMnthlyHlthSftyCmmttMeeting,
    needsAnnlHlthChck,
    needsAnnlHlthChckAdmin,
    needsAnnlHlthChckExam,
    needsAnnlStrssCheck,
    needsAdhocPrsnlReporting,
    needsAdhocIncdntReporting,
    healthClinic,
    nbIndusPhysician,
    nbHlthPromoter,
    nbHlthSftyPromoter,
    nbHlthOfficer,
    nbCmpnyMgmt,
    nbEmplyRepresentative,
    nbSftyOfficer,
    nbHlthSftyManager,
    needsHlthChckSummary,
    requiredCmpnyMgmt,
    requiredClinic,
    requiredCmpnyMgmtIncRprt,
    needsHlthCmmtt,
    needsSetup,
    needsIndusPhysician,
    needsSftyOfficer,
  };
}
